import { render, staticRenderFns } from "./centerBottom.vue?vue&type=template&id=0972fdaa&scoped=true&"
import script from "./centerBottom.vue?vue&type=script&lang=js&"
export * from "./centerBottom.vue?vue&type=script&lang=js&"
import style0 from "./centerBottom.vue?vue&type=style&index=0&id=0972fdaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0972fdaa",
  null
  
)

export default component.exports